<div ngbDropdown class="vox-dropdown-input">
  <button type="button" ngbDropdownToggle>{{'common.' + selectedIntegrationEnabled | translate}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let value of INTEGRATION_ENABLED"
      (click)="selectIntegrationEnabled(value)">{{'common.' + value | translate}}</button>
  </div>
</div>